import { render, staticRenderFns } from "./GoodsSeriesInspirationList.vue?vue&type=template&id=509b0690&"
import script from "./GoodsSeriesInspirationList.vue?vue&type=script&lang=js&"
export * from "./GoodsSeriesInspirationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports